import { render, staticRenderFns } from "./ConfigRecordDialog.vue?vue&type=template&id=ac64a490&scoped=true&"
import script from "./ConfigRecordDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac64a490",
  null
  
)

export default component.exports